import { ReactNode } from "react";
import clsx from "clsx";


function isVisibleClassNames(isVisible: boolean) {
    return clsx(
        'transition-opacity duration-300 ease-in-out',
        isVisible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none',
    );
}

export function MediaViewMediaFrame({ children, isVisible }: { children: ReactNode, isVisible: boolean }) {
    return (
        <span
            className={clsx(
                isVisibleClassNames(isVisible),
                'absolute inset-0 flex flex-auto',
            )}
        >
            {children}
        </span>
    )
}

export function MediaViewLoadingFrame({ children, isVisible }: { children: ReactNode, isVisible: boolean }) {
    return (
        <span
            className={clsx(
                isVisibleClassNames(isVisible),
                'absolute inset-0 flex flex-auto',
            )}
        >
            {children}
        </span>
    )
}

export function MediaViewErrorFrame({ children, isVisible }: { children: ReactNode, isVisible: boolean }) {
    return (
        <span
            className={clsx(
                isVisibleClassNames(isVisible),
                'absolute inset-0 flex flex-auto justify-self-center',
            )}
        >
            {children}
        </span>
    )
}

export function MediaViewInfoMenuFrame({ children }: { children: ReactNode }) {
    return (
        <>{children}</>
    )
}
